import React from "react";

export const MetaChip: React.FC<{ icon: React.ReactNode; label: string }> = ({
  icon,
  label,
}) => (
  <span className="inline-flex items-center gap-1.5 text-xs text-white/90 backdrop-blur-sm bg-gray-100/50 px-2.5 py-1 rounded-full">
    <span className="text-[11px]">{icon}</span>
    {label}
  </span>
);
